export default {
  methods: {
    formItemErrorClass(validation, extra = {}) {
      if (!validation) return extra;
      return { "is-error": validation.$error, ...extra };
    },
  },
};
